import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import tvImage from "../../../assets/images/tataplay-tv-image.png";
import logo from "../../../assets/images/logo-updated.png";
import bottomshape from "../../../assets/images/tataplay-bottom.png";
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { faAt, faKey, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChainIdSelectionPopup } from "./ChainIdSelectionPopup";
import { getUserRoleCodeFromStorage, isAutoModeViewerUser, setChainIdLS } from "../../../utils/utils";
import { useDispatch } from "react-redux";
import { setViewTypeAction } from "../../../store/actions/GetViewType/SetViewTypeActions";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onChange'
  });
  const [apiError, setApiError] = useState([]);
  const [isLinkDisabled, setIsLinkDisabled] = useState(true);
  const [mfaResponse, setMfaResponse] = useState("");
  const [mfaErrorResponse, setMfaErrorResponse] = useState("");
  const [counter, setCounter] = useState(0);
  // const [chainIdPopup, setChainIdPopup] = useState(false)

  useEffect(() => {
    reset();
  }, [reset]);

  useEffect(() => {
    if (counter > 0) {
      const timeout = setTimeout(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    } else {
      setIsLinkDisabled(false);
      setMfaErrorResponse("");
      setMfaResponse("");
    }
  }, [counter]);

  const handleMfaRequest = () => {
    const payload = { username: watch("username") };
    setCounter(30);
    setIsLinkDisabled(true);
    setMfaErrorResponse("");
    setMfaResponse("");
    setApiError([]);
    Axios.post(`${process.env.REACT_APP_BASE_URL}/user/mfa`, payload)
      .then((response) => {
        setMfaErrorResponse("");
        setMfaResponse(response.data?.message);
      })
      .catch((error) => {
        setIsLinkDisabled(false);
        setMfaResponse("");
        setMfaErrorResponse(error.response?.data?.errors);
      });
  };

  const onSubmit = (data) => {
    Axios.post(`${process.env.REACT_APP_BASE_URL}/auth`, data)
      .then((response) => {
        const userDetails = response.data.userDetails;
        const { permissions } = userDetails;
        const { roles } = userDetails;
        userDetails.availablePermissions = permissions.reduce((acc, item) => {
          if (item.active) {
            acc.push(item.permissionCode);
          }
          return acc;
        }, []);
        userDetails.availableRoles = roles.reduce((acc, item) => {
          if (item.active) {
            acc.push(item.roleCode);
          }
          return acc;
        }, []);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        localStorage.setItem("jwt", response.data.jwt);
        localStorage.setItem("currentRole", response.data.currentRole);
        // if(userDetails.availableRoles?.includes("ROLE_SUPER_ADMIN")){
        //   setChainIdPopup(true)
        // }
        // else if(userDetails?.chainIdHotelNameMapping?.length>1){
        //   setChainIdPopup(true)
        // }
        // else{
        const initialChainId = userDetails?.chainIdHotelNameMapping?.[0]?.chainId;
        if (initialChainId) {
          setChainIdLS(initialChainId);
        }
        if (userDetails?.chainIdHotelNameMapping?.[0]?.viewType) {
          dispatch(setViewTypeAction(userDetails.chainIdHotelNameMapping[0].viewType));
        }
          navigationPageHandler()
        // }
        reset();
      })
      .catch((error) => {
        setApiError(error?.response?.data?.errors);
      });
  };

  const navigationPageHandler = ()=>{
    // setChainIdPopup(false)
    const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
    const userRoleCode = getUserRoleCodeFromStorage();

    if (isAutoModeViewerUser()) {
      navigate("/hms/APKInstallationDetails");
      return;
    }

    if(userRoleCode !== "ROLE_SUPER_ADMIN"){
      navigate("/hms/HotelOnboardingWizard");
    }
    else if(userDetails?.availableRoles?.includes("ROLE_SUPER_ADMIN") || userDetails?.availablePermissions?.includes("MENU_HOTEL_DASHBOARD")){
      navigate("/hms/Dashboard/Hotels_Dashboard");
    }
    else if(userDetails?.availablePermissions?.includes("MENU_CONFIGURATION_NEW_HOTEL")){
      navigate("/hms/ConfigurationNewHotel");
    }
    else if(userDetails?.availablePermissions?.includes("MENU_CONFIGURATION_NEW_ROOM")){
      navigate("/hms/ConfigurationNewRoom");
    }
    else if(userDetails?.availablePermissions?.includes("MENU_CONFIGURATION_MANAGEMENT")){
      navigate("/hms/HeroBanner");
    }
    else if(userDetails?.availablePermissions?.includes("MENU_WELCOME_MESSAGES")){
      navigate("/hms/WelcomeMessages");
    }
  }

  return (
    <div className="login-container row">
      <div className="left-panel col-6">
        <div className="left-panel-tv-logo">
          <img src={tvImage} alt="left panel setup box" />
        </div>
        <div className="left-panel-logo">
          <img src={logo} alt="login logo" />
        </div>
        <div className="left-panel-shape">
          <img src={bottomshape} alt="login bottom shape" />
        </div>
      </div>
      <div className="right-panel col-6">
        <div className="form-wrapper">
          <h2>Welcome To HMS!</h2>
          <p className="login-title">Please Login to your account.</p>
          {apiError?.map((data, index) => (
            <p className="login-error" key={index}>
              {data}
            </p>
          ))}
          <p className="login-success">{mfaResponse}</p>
          <p className="login-error">{mfaErrorResponse}</p>
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group position-relative">
              <FontAwesomeIcon icon={faAt} className="login-icons" />
              <label htmlFor="username">Email</label>
              <input
                type="text"
                id="username"
                autoComplete="new-password"
                className="form-control"
                placeholder="Enter your email"
                maxLength={60}
                {...register("username", {
                  required: "Email required in correct format",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Required in correct format",
                  },
                })}
              />
              {errors.username && <small>{errors.username.message}</small>}
            </div>
            <div className="form-group position-relative">
              <FontAwesomeIcon icon={faKey} className="login-icons" />
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                placeholder="Enter your password"
                autoComplete="new-password"
                className="form-control"
                {...register("password", { required: "Please Enter Password" })}
              />
              {errors.password && <small>{errors.password.message}</small>}
            </div>
            <div className="form-group position-relative">
              <FontAwesomeIcon icon={faShieldAlt} className="login-icons" />
              <label htmlFor="mfa">MFA Code</label>
              <div className="mfa-input-group">
                <input
                  type="text"
                  id="mfaCode"
                  className="form-control"
                  placeholder="Enter MFA Code"
                  {...register("mfaCode", { required: "Please Enter MFA Code" })}
                />
                {errors.mfaCode && <small>{errors.mfaCode.message}</small>}
              </div>
            </div>
            <div className="form-group flex-items-between">
              <Link to="/forgotPassword">
                <p className="trouble-shoot">Trouble logging in?</p>
              </Link>
              <button
                type="button"
                className={`mfa-btn ${(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(watch("username"))) || isLinkDisabled ) ? "inactive-mfa" : "active-mfa"}`}
                onClick={handleMfaRequest}
                disabled={isLinkDisabled || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(watch("username")))}
              >
                {isLinkDisabled
                  ? `Resend MFA Code In ${counter} sec`
                  : "Send MFA Code"}
              </button>
            </div>
            <div className="col-7 mx-auto">
              <button type="submit" className="login-btn">
                Login
              </button>
            </div>
            <div className="col-8 create-account">
              <Link to="/signup">
                If you don't have an account? Create
              </Link>
            </div>
          </form>
        </div>
      </div>
      {/* <ChainIdSelectionPopup isOpen={chainIdPopup} closePopupHandler={navigationPageHandler}/> */}
    </div>
  );
};

export default Login;
